<ion-row>
  <ion-col>
    <ion-text color="primary">{{location.name}}</ion-text>
    <ion-row>
      <span>
        <ion-icon class="small_icons" color="primary" name="assignment-ind"></ion-icon>
      </span>
      <span *ngIf="location.customer">
        <ion-text>{{location.customer.name}}</ion-text>
      </span>
    </ion-row>
    <ion-row>
      <span>
        <ion-icon class="small_icons" color="primary" name="chatbox-ellipses-outline"></ion-icon>
      </span>
      <span>
        <ion-text>{{location.comment}}</ion-text>
      </span>
    </ion-row>
  </ion-col>

  <ion-col class="nav-button">
    <ion-row>
      <ion-fab-button style="transform: scale(0.6);" size="small" (click)="navigateToLocation()">
        <ion-icon name="navigate-outline" class="icon-button inner-center-btn"></ion-icon>
      </ion-fab-button>
    </ion-row>
  </ion-col>
</ion-row>
